import initTabs from './tabs';
import initIcon from './icon';
import initWaterfall from './waterfall';
import initNvAlert from './nv-alert';

export default (editor, opts = {}) => {
  initTabs(editor, opts);
  initIcon(editor, opts);
  initWaterfall(editor, opts);
  initNvAlert(editor, opts);
};
